
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 548 548"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M274 0C122.7 0 0 122.7 0 274s122.7 274 274 274 274-122.7 274-274S425.3 0 274 0zm91.5 234.1c.3 1.2.5 3 .5 5.6 0 20.7-5.1 40.7-15.1 60-10.4 20.4-24.9 36.7-43.6 48.8-20.4 13.5-43.9 20.3-70.3 20.3-25.3 0-48.5-6.8-69.5-20.3 3.2.3 6.8.4 10.8.4 21 0 39.9-6.5 56.5-19.4-10.1 0-18.9-3-26.6-8.9-7.6-5.9-12.9-13.3-15.8-22.2 2.9.3 5.6.4 8.2.4 4 0 8-.4 12.1-1.3-10.4-2.3-19-7.6-25.9-16s-10.4-17.9-10.4-28.5v-.8c6.3 3.7 13.1 5.7 20.3 6-6-4.3-10.9-9.8-14.7-16.4-3.7-6.6-5.6-13.9-5.6-21.8s2.1-15.4 6.5-22.6c11.2 14.1 25 25.3 41.2 33.6 16.3 8.4 33.6 12.9 52 13.8-.6-3.5-.8-6.9-.8-10.4 0-8 2-15.6 6-22.6 4-7.1 9.5-12.6 16.4-16.6s14.4-6 22.4-6c6.6 0 12.7 1.3 18.3 3.9 5.6 2.6 10.6 6 14.9 10.4 10.4-2 20-5.6 28.9-10.8-3.5 10.7-10.1 19-19.9 25.1 8.7-1.2 17.2-3.6 25.9-7.3-6.1 9.1-13.7 17-22.7 23.6z","fill":"#47474c"}})])
          )
        }
      }
    